import { render, staticRenderFns } from "./GlobeMyFolder.vue?vue&type=template&id=53055e96&scoped=true&"
import script from "./GlobeMyFolder.vue?vue&type=script&lang=js&"
export * from "./GlobeMyFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53055e96",
  null
  
)

export default component.exports